var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-app",class:'chart-' + _vm.chartId},[_c('chart',{ref:"chart",attrs:{"chart-id":_vm.chartId,"chart-data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }